import React, { useState, useEffect } from "react"
import logo from "../assets/logo.jpg"

export const CookieConsent: React.FC = () => {
	const [showCookieModal, setShowCookieModal] = useState(false)

	// Sprawdzanie, czy użytkownik już zaakceptował cookies
	useEffect(() => {
		const cookiesAccepted = localStorage.getItem("cookiesAccepted")
		if (!cookiesAccepted) {
			setShowCookieModal(true)
		}
	}, [])

	// Funkcja obsługująca akceptację cookies
	const handleAcceptCookies = () => {
		localStorage.setItem("cookiesAccepted", "true")
		setShowCookieModal(false)
	}

	if (!showCookieModal) return null

	return (
		<div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
			<div className='bg-white rounded-lg shadow-lg p-8 max-w-lg w-full relative'>
				<div className='flex items-center mb-4'>
					<img src={logo} alt='Logo firmy' className='w-12 h-12 mr-4' />
					<h3 className='text-xl font-bold text-gray-800'>
						Używamy plików cookies
					</h3>
				</div>
				<p className='text-gray-600 mb-6'>
					Nasza strona internetowa wykorzystuje pliki cookies, aby zapewnić Ci
					najlepsze możliwe doświadczenie użytkownika. Kontynuując korzystanie z
					witryny, zgadzasz się na ich użycie.
				</p>
				<div className='flex justify-end'>
					<button
						onClick={handleAcceptCookies}
						className='bg-accent text-white py-2 px-4 rounded hover:bg-orange-500 transition'>
						Akceptuję
					</button>
				</div>
			</div>
		</div>
	)
}
